import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function BottomSheet({
  isOpen,
  onClose,
  title,
  children
}: BottomSheetProps) {
  return <AnimatePresence data-id="element-130" data-mp="1mi5eq2w11y3z">
      {isOpen && <div className="absolute inset-0 z-30 flex flex-col justify-end" data-id="element-131" data-mp="1mh441zixbdms">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-0 bg-slate-900/40" onClick={onClose} aria-hidden="true" data-id="element-132" data-mp="18hun2xmw8fhr" />
          <motion.div role="dialog" aria-modal="true" aria-label={title} initial={{
        y: '100%',
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: '100%',
        opacity: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative z-10 max-h-[85%] overflow-y-auto rounded-t-3xl bg-white px-5 pb-6 pt-4 shadow-2xl" data-id="element-133" data-mp="13m5tdaxk1std">
            <div className="mx-auto mb-4 h-1 w-10 rounded-full bg-slate-200" data-id="element-134" data-mp="1zayvj2yhiybl" />
            <div className="mb-4 flex items-center justify-between" data-id="element-135" data-mp="1ubughvovq6dc">
              <h2 className="text-lg font-semibold text-slate-900" data-id="element-136" data-mp="1udylkgyilbf7">{title}</h2>
              <button type="button" onClick={onClose} aria-label="Close" className="flex h-8 w-8 items-center justify-center rounded-full text-slate-400 transition-colors duration-150 hover:bg-slate-100 hover:text-slate-600" data-id="element-137" data-mp="16m9zvjg77l78">
                <XIcon className="h-5 w-5" data-id="element-138" data-mp="1bjtdch52nty4" />
              </button>
            </div>
            {children}
          </motion.div>
        </div>}
    </AnimatePresence>;
}